import { render, staticRenderFns } from "./StockProductDepartmentPicker.vue?vue&type=template&id=53d0b808"
import script from "./StockProductDepartmentPicker.vue?vue&type=script&lang=js"
export * from "./StockProductDepartmentPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports